<template>
  <div style="width: 100vw;height: 100vh;background: black;position:relative;">
    <div id="map"></div>
    <TraceSourceMarkerEntry :marker-list="traceSourceMarkerList"></TraceSourceMarkerEntry>

    <div style="width: 100%;height: 64px;opacity: 1;background: rgba(81, 122, 5, 0.4);box-shadow: 0 2px 4px  rgba(0, 0, 0, 0.25);position:absolute;bottom: 0;z-index:900">
      <div style="margin: 15px auto 0 auto;width: fit-content;display: flex">

        <!--溯源按钮-->
        <div style="width: fit-content" @click="navigateToIndex">
          <span class="iconfontFamily" style="font-size: 17px;color: white;display: block;text-align: center">&#xe836;</span>
          <p class="alimamaShuHeiTiFontFamily" style="font-size: 12px;line-height: 12px;color: white;margin-top: 5px;display: block">溯源</p>
        </div>

        <!--严选按钮-->
        <div style="width: fit-content;margin-left: 120px">
          <span class="iconfontFamily" style="font-size: 14px;color: rgba(145, 240, 22, 1);display: block;text-align: center">&#xe837;</span>
          <p class="alimamaShuHeiTiFontFamily" style="font-size: 12px;line-height: 12px;color: rgba(145, 240, 22, 1);margin-top: 8px;display: block">严选</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {getMapboxToken} from "@/utils/utils";
import mapboxgl from "mapbox-gl";
import TraceSourceMarkerEntry from "@/components/TraceSourceEntry/TraceSourceMarkerEntry.vue";

export default {
  name: 'CarefullySelectedPage',
  components: {TraceSourceMarkerEntry},
  data() {
    return {
      map: '',
      traceSourceMarkerList: [],
      image: 'https://market.obs.cn-north-4.myhuaweicloud.com:443/202604071536000138724.png',
    }
  },
  methods: {
    async initMap() {
      await getMapboxToken()
      mapboxgl.accessToken = this.globalJS.mapboxToken;
      this.map = new mapboxgl.Map({
        container: 'map',
        center: [104, 37],
        zoom: 2,
        style: this.globalJS.mapboxStyle,
        preserveDrawingBuffer: true,
        localIdeographFontFamily: '',
        projection: {name: 'globe'},
        transformRequest: (url) => {
          if (url.indexOf('https://api.mapbox.com') > -1) {
            return {
              url: url.replace('https://api.mapbox.com', 'https://earth.jl1.cn/mapbox'),
            };
          }
        }
      })
      this.map.on('load', () => {
        this.map.addSource('worldSkinLow', {
          type: 'raster',
          tiles: [
            'https://earthtile.jl1.cn/tileWorld/tile/tms/worldSkin/{z}/{x}/{y}'
          ],
          tileSize: 256,
          scheme: 'tms',
        });

        this.map.addSource('worldSkinHigh', {
          type: 'raster',
          tiles: [
            this.globalJS.world1mUrl_2021
          ],
          tileSize: 256,
          scheme: 'tms',
        });

        this.map.addLayer({
          id: 'worldSkinLowLayer',
          type: 'raster',
          source: 'worldSkinLow',
          minzoom: 0,
          maxzoom: 9,
          paint: {
            'raster-opacity': {
              stops: [
                [7, 1],
                [8, 1],
                [9, 0]
              ]
            }
          }
        });

        this.map.addLayer({
          id: 'worldSkinHighLayer',
          type: 'raster',
          source: 'worldSkinHigh',
          minzoom: 7,
          paint: {
            'raster-opacity': {
              stops: [
                [7, 0],
                [8, 0.5],
                [9, 1]
              ]
            }
          }
        });
      })
      this.getData()
    },
    getData(){
      this.$http.get('/earthApi/t-product/getTProductList').then(response => {
        if(response.body.status === 200){
          console.log(response.body)
          console.log(response.body.data.length)
          this.traceSourceMarkerList = response.body.data
        } else{
          console.log(response.data.status + response.data.message)
        }
      })
    },
    navigateToIndex(){
      // eslint-disable-next-line no-undef
      if (typeof wx !== 'undefined' && wx.miniProgram){
        // eslint-disable-next-line no-undef
        wx.miniProgram.navigateBack()
        // wx.miniProgram.navigateTo({url: '/pages/index/index'})
      }
    }
  },
  mounted() {
    this.initMap()
  }
}
</script>

<style scoped>
#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
</style>